// Функция для глубокого создания свойств объекта, если они отсутствуют

export default (obj, pathArray) => {
  let current = obj;
  for (let idx = 0; idx < pathArray.length; idx++) {
    if (!current[pathArray[idx]]) {
      current[pathArray[idx]] = {};
    }
    current = current[pathArray[idx]];
  }

  return current;
};
